import React from 'react';

export default function Podcasts() {
  const episodes = [
    {
      title: 'How to migrate 1,000+ applications to the cloud?',
      show: 'Charlas Técnicas de AWS',
      episode: 'Season 3, Episode 19',
      description: 'A deep dive with Alberto Menendez and Alexander Cabezas on what it takes to migrate 600, 1,000 or more applications to the cloud. Drawing from hands-on AWS consulting experience, they share the strategy, challenges, and lessons learned from large-scale migration engagements.',
      chapters: [
        '00:00 - Introduction',
        '03:40 - What do we mean by migrations?',
        '08:15 - What are the benefits of migrating applications?',
        '16:46 - Application migration, processes, and culture',
        '30:15 - How is a migration carried out?',
        '37:15 - The 7 Rs',
        '56:16 - What roles are involved in a migration?',
        '01:01:46 - What about modernization?',
        '01:05:12 - Where to start?',
      ],
      url: 'https://podcast.marcia.dev/932377/episodes/11509505-3-19-como-migrar-mas-de-1000-aplicaciones-a-la-nube',
      icon: '🎙️',
    },
    {
      title: 'Migrating Mainframe applications at scale',
      show: 'Podcast AWS LATAM',
      episode: 'EP103',
      description: 'Alberto Menendez and Alexander Cabezas explore the options AWS offers for migrating Mainframe applications at scale, covering automated code conversion tools and virtualization strategies — and what it actually takes to pull off a large-scale mainframe modernization.',
      chapters: null,
      url: 'https://open.spotify.com/episode/68pxPtx5A0DuVJ2bc5aUqr',
      icon: '☁️',
    },
  ];

  return (
    <section id="podcasts" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Podcast Appearances
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto">
            AWS podcast episodes on cloud migrations, mainframe modernization, and the 7 Rs
          </p>
        </div>

        <div className="space-y-8">
          {episodes.map((ep, index) => (
            <a
              key={index}
              href={ep.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-gray-50 border-2 border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-blue-500 transition group"
            >
              <div className="flex flex-col sm:flex-row sm:items-start gap-4">
                <div className="flex-shrink-0 w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center text-3xl group-hover:bg-blue-200 transition">
                  {ep.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-medium rounded">
                      {ep.show}
                    </span>
                    <span className="px-2 py-0.5 bg-gray-200 text-gray-600 text-xs font-medium rounded">
                      {ep.episode}
                    </span>
                    <span className="px-2 py-0.5 bg-yellow-100 text-yellow-700 text-xs font-medium rounded">
                      🇪🇸 In Spanish
                    </span>
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 group-hover:text-primary transition">
                    {ep.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-600 mb-4">
                    {ep.description}
                  </p>
                  {ep.chapters && (
                    <details className="mb-3">
                      <summary className="text-sm font-medium text-gray-700 cursor-pointer hover:text-primary">
                        Table of Contents
                      </summary>
                      <ul className="mt-2 space-y-1 text-xs text-gray-600 pl-4 border-l-2 border-gray-200">
                        {ep.chapters.map((chapter, i) => (
                          <li key={i}>{chapter}</li>
                        ))}
                      </ul>
                    </details>
                  )}
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary">
                    Listen to episode
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
